export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14595.920d34da.jpg";